// LA CADENCE D'UN SON RÉPÉTÉ — règle pure, donc vérifiable (06/08).
//
// `client/audio.ts` construit un AudioContext et écoute `document` dès son chargement : il ne
// s'importe pas dans un test. Or la règle qui suit mérite d'être testée — c'est elle qui empêche
// un ressort de se transformer en mitraillette.
//
// Le cas mesuré : un trampoline surmonté d'un plafond bas coupe le rebond net, le coureur retombe,
// ré-atterrit, rebondit — onze « boings » en cinq secondes, sans que personne touche à rien.
// Le rebond lui-même reste inchangé (c'est une vraie situation de jeu, parfois voulue) ; seule sa
// VOIX est bornée, et côté client uniquement : rien ici n'entre dans la simulation ni dans le hash.

/** Délai minimal entre deux « boings » d'un même coureur, en millisecondes. */
export const CADENCE_BOING_MS = 500

/**
 * Ce son peut-il être joué maintenant pour cette source ? Met la mémoire à jour si oui.
 *
 * La mémoire est PAR SOURCE (l'index du coureur) : en versus, deux joueurs qui rebondissent en
 * même temps doivent s'entendre tous les deux — un limiteur global en aurait tu un des deux.
 *
 * @param derniers  mémoire des derniers passages, par source (mutée)
 * @param source    l'index du coureur
 * @param maintenant horloge en ms (passée en argument : la règle reste pure et testable)
 * @param minMs     délai minimal, par défaut celui du rebond
 */
export function cadenceOk(
  derniers: Map<number, number>,
  source: number,
  maintenant: number,
  minMs: number = CADENCE_BOING_MS,
): boolean {
  const dernier = derniers.get(source)
  if (dernier !== undefined && maintenant - dernier < minMs) return false
  derniers.set(source, maintenant)
  return true
}
